import { Container, ContainerProps, Flex } from "@chakra-ui/react";

export function Layout(props: ContainerProps) {
  return (
    <Flex alignItems={["normal", "normal", "center"]} marginTop="auto">
      <Container {...props} maxWidth={"container.md"}></Container>
    </Flex>
  );
}
